import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MultiUpload from './MultiUpload';
import axios from 'axios'
import Input from './UI/Input/Input'
import { define, tokenExpiredMsg, expNotifyDuration } from '../data/globals'
import MyEditor from './UI/MyEditor/MyEditor'
import { useNotify } from '../hooks/useNotify';


const ProdFormAdd = (props) => {
    const newProdStore = useSelector(state => state.newProd)
    const newPicsStore = useSelector(state => state.newPics)
    const dispath = useDispatch()
    const [isFilled1, setIsFilled1] = useState(false)
    const [isFilled2, setIsFilled2] = useState(false)
    const { pushNotify } = useNotify()


    function inputName(event) {
        dispath({ type: 'SetNewProdTitle', name: event.target.value})
        // сняте подсветки, если поле заполнено
        if(event.target.value.length > 0) setIsFilled1(false);
        else setIsFilled1(true)
    }
    // // Для простого инпута:
    // function inputDescr(event) {
    //     dispath({ type: 'SetNewProdDescr', description: event.target.value})
    //     // сняте подсветки, если поле заполнено
    //     if(event.target.value.length > 0) setIsFilled2(false);
    //     else setIsFilled2(true)
    // }
    // // Для tinyMCE редактора:
    // function inputDescr(editorText) {
    //     dispath({ type: 'SetNewProdDescr', description: editorText })
    //     // сняте подсветки, если поле заполнено
    //     if(editorText.length > 0) setIsFilled2(false);
    //     else setIsFilled2(true)
    // }
    // Для tinyMCE редактора (функция 1):
    function inputDescrEditorChange(editorText) {
        dispath({ type: 'SetNewProdDescr', description: editorText })
    }
    // Для tinyMCE редактора (функция 2):
    function inputDescrEditorKeyUp(){
        // сняте подсветки, если поле заполнено
        if(newProdStore.description.length > 0) setIsFilled2(false);
        else setIsFilled2(true)
    }
    // В tinyMCE onEditorChange отрабатывает не совсем так, как onChange у стандартного поля input. Поэтому приходится использовать onKeyUp. И, соответственно, вместо одной функции, использовать 2 (inputDescrEditorChenge и inputDescrEditorKeyUp)
    
    let filteredValue
    function inputPrice(e) {
        // оставляем только цыфры и точку
        filteredValue = e.target.value.replace(/[^.\d]+/g,"").replace( /^([^.]*\.)|\./g, '$1' )
        dispath({ type: 'SetNewProdPrice', price: filteredValue})
    }

    function checkForm(e) {
        e.preventDefault()
        let pointsToGo = 2
        // подсветка пустых полей
        if(newProdStore.name.length === 0) { setIsFilled1(true); pointsToGo-- }
        if(newProdStore.description.length === 0) { setIsFilled2(true); pointsToGo-- }
        // Поля заполнены - добавляем товар
        (pointsToGo === 2) ? createProduct()
            : pushNotify("Заполните обязательные поля,<br>чтобы добавить товар", "notifyRed")
            // : props.pushNotify("Заполните обязательные поля,<br>чтобы добавить товар", "notifyRed")
    }
    // function createProduct() {
    async function createProduct() {

        try {
            const response = await axios({
                method: 'post',
                url: define.pathToAPI + '/products/create.php',
                data: JSON.stringify({
                    id: newProdStore.id,
                    name: newProdStore.name,
                    description: newProdStore.description,
                    pictures: newPicsStore,
                    price: Number(newProdStore.price).toFixed(2),
                    categoryId: newProdStore.categoryId,
                    userToken: localStorage.getItem('AuthToken'),
                }),
            })

            // проверка ответа от create.php
            switch(response.data.message){
                case 'Товар создан':
                    setIsFilled1(false)
                    setIsFilled2(false)
                    props.create()
                    setIsFilled1(false)
                    setIsFilled2(false)
                    break
                case 'Токен устарел!':
                    pushNotify(tokenExpiredMsg, "notifyWelcome", expNotifyDuration)
                    // props.pushNotify(tokenExpiredMsg, "notifyWelcome", expNotifyDuration)
                    // ########################################################
                    // При блокировке доступа, удалить картинки, которые не были сохранены в базе
                    // ########################################################
                    break
                case 'Токены не совпадают! Доступ запрещен':
                    pushNotify("Токены не совпадают! Alarm! Доступ запрещен", "notifyWelcome")
                    // props.pushNotify("Токены не совпадают! Alarm! Доступ запрещен", "notifyWelcome")
                    // ########################################################
                    // При блокировке доступа, удалить картинки, которые не были сохранены в базе
                    // ########################################################
                    break
                default:
                    console.log('Ошибка при добавлении товара.\nСервер отвечает (код 200). Но нет подтверждения от create.php, что товар добавлен в базу')
                    alert('Ошибка при добавлении товара (см.  консоль)')
                    break
            } // switch

        } catch (e) {
            if(e === 'AxiosError: Request failed with status code 400') {
                console.log('Ошибка при добавлении товара.\nКод: 400 - Данные неполные\n(в create.php получены не все поля).')
                alert('Ошибка (код: 400) при добавлении товара (см.  консоль)')
            } else {
                console.log(e)
                alert('Ошибка при добавлении товара.\n' + e)
            }
        }
    }// createProduct

    return (
        <div className={ isFilled2 ? 'alarm-on' : 'alarm-off' }>
            <h1>{ props.header }</h1>
            <p className='mb-10'>Категория: <b>{ newProdStore.categoryName }</b></p>
            <form>
                Название:<br/>
                <Input
                    className={`form-input w540 ${(isFilled1) ? "notfilled" : ""}`}
                    value={ newProdStore.name }
                    onChange={ inputName }
                    placeholder=""
                />
                <div className="tooltip mb-10">
                { isFilled1 && <div className="tooltiptext ml-90 mt-7">Заполните название</div> }
                </div>
                
                <MultiUpload />
                Цена:
                <Input
                    className={`form-input w100 text-center ml-10 mr-4 mb-10`}
                    value={ newProdStore.price }
                    onChange={ inputPrice }
                    placeholder=""
                /> грн.<br/>
                Описание:<br/>
                <MyEditor
                    value={ newProdStore.description }
                    onEditorChange={ inputDescrEditorChange }
                    onKeyUp={ inputDescrEditorKeyUp }
                />
                <div className="tooltip mb-15">
                { isFilled2 && <div className="tooltiptext ml-90 mt-m20">Заполните описание</div> }
                </div>

                <button onClick={ checkForm } className='btn greenBtn'>Добавить</button>
            </form><br/>
        </div>
    )
}

export default ProdFormAdd